var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "np_green-consumption_3485239_000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.971,
    height: 48.581,
    viewBox: "0 0 81.971 48.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M49.114,24.738a24.293,24.293,0,0,0-7.79,47.3,1.877,1.877,0,1,0,1.2-3.557,20.553,20.553,0,1,1,8.467.992V63.469a11.634,11.634,0,0,0,7.741-18.01L50.669,33.583h0a1.878,1.878,0,0,0-3.106,0L39.5,45.46a11.45,11.45,0,0,0-1.7,9.229,11.728,11.728,0,0,0,5.754,7.535,1.879,1.879,0,0,0,1.8-3.3,7.953,7.953,0,0,1-3.9-5.116A7.741,7.741,0,0,1,42.6,47.571l4.635-6.825v30.57c0,.023,0,.041,0,.06s0,.041,0,.06v0a1.879,1.879,0,0,0,1.878,1.878,24.29,24.29,0,0,0,0-48.581ZM56.07,55.676h0a7.728,7.728,0,0,1-5.074,3.963v-3.91L56.7,49.87a7.74,7.74,0,0,1-.635,5.807Zm-5.078-5.33v-9.6L54.835,46.4Z",
    transform: "translate(-8.046 -24.737)",
    fill: "#2c2b34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M15.672,25.188a8.307,8.307,0,0,0-8.3,8.3V38.6a8.311,8.311,0,0,0,6.419,8.083V70.981a1.878,1.878,0,0,0,3.756,0V46.687A8.311,8.311,0,0,0,23.969,38.6V33.485a8.3,8.3,0,0,0-8.3-8.3ZM20.213,38.6a4.541,4.541,0,1,1-9.082,0V33.485a4.541,4.541,0,0,1,9.082,0Z",
    transform: "translate(-7.375 -24.755)",
    fill: "#2c2b34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M90.083,27.1a1.879,1.879,0,0,0-1.878,1.878v7.9a4.551,4.551,0,0,1-2.663,4.135V28.937a1.878,1.878,0,0,0-3.756,0V41.013a4.545,4.545,0,0,1-2.663-4.135v-7.9a1.878,1.878,0,1,0-3.756,0v7.9a8.311,8.311,0,0,0,6.419,8.083v24.3a1.878,1.878,0,0,0,3.756,0V44.96a8.311,8.311,0,0,0,6.419-8.083v-7.9A1.872,1.872,0,0,0,90.083,27.1Z",
    transform: "translate(-9.99 -24.827)",
    fill: "#2c2b34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.e4432b8eb9ea64f528827882735d2aa1.svg";
export { ForwardRef as ReactComponent };